export default __webpack_public_path__ + "static/devops@2x-7e6d482640a60994b72074f5955c5fa6.png";